import React, { useEffect, useState } from "react"
import Day from "../DayComponent/day"
import ReolinkStream from "../ReolinkStreamComponent/reolinkstream"
import Weather from "../WeatherComponent/weather"
import WeatherRadar from "../WeatherRadarComponent/weatherradar"
import { apiUrl } from "../../api"
import "./ui.css"

function Interface({ match }) {
     const [selectedCamera, setSelectedCamera] = useState({ id: "", name: "Kamera 1" })
     const cameraPage = Number(match?.params?.cameraPage || 0)

     useEffect(() => {
          fetch(apiUrl("/controller/reolink/cameras/settings"))
               .then((response) => response.json())
               .then((data) => {
                    const configuredCameras = (data.cameras || []).filter((camera) => camera.host || camera.streamUrl)
                    if (!configuredCameras.length) {
                         setSelectedCamera({ id: "", name: "Kamera 1" })
                         return
                    }

                    if (cameraPage > 0) {
                         setSelectedCamera(configuredCameras[cameraPage - 1] || configuredCameras[0])
                         return
                    }

                    setSelectedCamera(configuredCameras.find((camera) => camera.id === data.defaultCameraId) || configuredCameras[0])
               })
               .catch(() => setSelectedCamera({ id: "", name: "Kamera 1" }))
     }, [cameraPage])

     return (
          <main className="background contentfet">
               <section className="wrapstream" aria-label="Casa Giu Weather">
                    <Day />
                    <div className="image">
                         <div className="streamarea">
                              <ReolinkStream key={selectedCamera.id || "legacy"} cameraId={selectedCamera.id || ""} cameraName={selectedCamera.name || selectedCamera.id || "Kamera"} />
                              <WeatherRadar />
                         </div>
                         <Weather />
                    </div>
               </section>
               <header className="appheader">
                    <h1>
                         Casa Giu
                         <span>Vibo Marina, Calabria</span>
                    </h1>
               </header>
          </main>
     )
}

export default Interface
